import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-dark/95 backdrop-blur-lg border-b-2 border-primary/30 shadow-xl shadow-primary/10' : 'bg-transparent'
    }`}>
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-4">
            {/* University Logo */}
            <img 
              src="/uni-logo.webp" 
              alt="COMSATS Logo" 
              className="h-10 w-10 object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center shadow-lg shadow-primary/30">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <div>
                <span className="text-xl md:text-2xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent font-heading">
                  Breaking the Matrix
                </span>
                <p className="text-xs text-gray-500 hidden md:block">Psychology Presentation</p>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-4 xl:space-x-6">
            <a href="#home" className="text-gray-300 hover:text-primary transition-colors duration-300 font-body text-sm xl:text-base">
              Home
            </a>
            <a href="#the-matrix" className="text-gray-300 hover:text-accent transition-colors duration-300 font-body text-sm xl:text-base">
              Matrix
            </a>
            <a href="#creativity-problem" className="text-gray-300 hover:text-secondary transition-colors duration-300 font-body text-sm xl:text-base">
              Problem
            </a>
            <a href="#break-free" className="text-gray-300 hover:text-warning transition-colors duration-300 font-body text-sm xl:text-base">
              Solution
            </a>
            <a href="#matrix-test" className="text-gray-300 hover:text-primary transition-colors duration-300 font-body text-sm xl:text-base">
              Test Yourself
            </a>
            <a href="#message" className="text-gray-300 hover:text-accent transition-colors duration-300 font-body text-sm xl:text-base">
              Message
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t-2 border-primary/20">
            <div className="flex flex-col space-y-4 pt-4">
              <a href="#home" onClick={() => setIsMenuOpen(false)} className="text-gray-300 hover:text-primary transition-colors duration-300 font-body">
                Home
              </a>
              <a href="#the-matrix" onClick={() => setIsMenuOpen(false)} className="text-gray-300 hover:text-accent transition-colors duration-300 font-body">
                The Matrix
              </a>
              <a href="#creativity-problem" onClick={() => setIsMenuOpen(false)} className="text-gray-300 hover:text-secondary transition-colors duration-300 font-body">
                The Problem
              </a>
              <a href="#break-free" onClick={() => setIsMenuOpen(false)} className="text-gray-300 hover:text-warning transition-colors duration-300 font-body">
                Break Free
              </a>
              <a href="#matrix-test" onClick={() => setIsMenuOpen(false)} className="text-gray-300 hover:text-primary transition-colors duration-300 font-body">
                Test Yourself
              </a>
              <a href="#message" onClick={() => setIsMenuOpen(false)} className="text-gray-300 hover:text-accent transition-colors duration-300 font-body">
                Message
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;